import { Option } from "@recore-solutions/nstar-lib";
import { ListingSortColumn } from "src/app/home/types/ListingSortColumn";

export const listingSotColumnOptions: (Option & { className: string })[] = [
	{ key: ListingSortColumn.MLID, value: "MLS #", className: "col-md-1", sortOrder: 1 },
	{ key: ListingSortColumn.MEMBER_NAME, value: "Agent Name", className: "col-md-3", sortOrder: 1 },
	{ key: ListingSortColumn.STATUS_NAME, value: "Status", className: "col-md-1", sortOrder: 1 },
	{ key: ListingSortColumn.CITY_NAME, value: "City", className: "col-md-3", sortOrder: 1 },
	{ key: ListingSortColumn.PRICE, value: "Price", className: "col-md-1", sortOrder: 1 },
	{ key: ListingSortColumn.DATE, value: "List Date", className: "col-md-1", sortOrder: 1 },
	{ key: ListingSortColumn.EXPIRATION, value: "Exp. Date", className: "col-md-1", sortOrder: 1 },
	{
		key: ListingSortColumn.MODIFICATION,
		value: "Recently Edited",
		className: "col-md-1",
		sortOrder: 1,
	},
];

export const isListingSortColumn = (s: any): s is ListingSortColumn => {
	return Object.values(ListingSortColumn).includes(s);
};

export const convertLegacyToPolarisSortColumn = (sortColumn: string): ListingSortColumn => {
	switch (sortColumn) {
		case "MLID":
			return ListingSortColumn.MLID;
		case "ListAgent1Name":
			return ListingSortColumn.MEMBER_NAME;
		case "Status":
			return ListingSortColumn.STATUS_NAME;
		case "City":
			return ListingSortColumn.CITY_NAME;
		case "ListPrice":
			return ListingSortColumn.PRICE;
		case "ListDate":
			return ListingSortColumn.DATE;
		case "ExpirationDate":
			return ListingSortColumn.EXPIRATION;
		case "RecentlyEdited":
			return ListingSortColumn.MODIFICATION;
		default:
			if (isListingSortColumn(sortColumn)) {
				return sortColumn;
			}
			return ListingSortColumn.MODIFICATION;
	}
};
